import * as React from 'react';

const RfidChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M12 14a2 2 0 110-4 2 2 0 010 4zM8.396 7.203L9.598 8.8A3.992 3.992 0 008 12c0 1.283.607 2.462 1.617 3.213l-1.193 1.605A5.992 5.992 0 016 12c0-1.91.9-3.671 2.396-4.797zm7.217 9.588l-1.205-1.596A3.992 3.992 0 0016 12a3.991 3.991 0 00-1.573-3.18l1.215-1.589A5.99 5.99 0 0118 12a5.991 5.991 0 01-2.387 4.79zM6.445 3.684l1.112 1.662A7.99 7.99 0 004 12a7.99 7.99 0 003.533 6.638l-1.118 1.658A9.99 9.99 0 012 12a9.99 9.99 0 014.445-8.316zM17.667 20.24l-1.135-1.648A7.989 7.989 0 0020 12a7.99 7.99 0 00-3.499-6.615l1.127-1.652A9.989 9.989 0 0122 12a9.988 9.988 0 01-4.333 8.24z" />
    </svg>
);

RfidChunkySvg.displayName = 'RfidChunkySvg';
export default RfidChunkySvg;
